"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.participantClassifier = exports.isStudent = exports.isTeacher = exports.isRoom = exports.isClass = void 0;
const isClass = (t) => /^\d\w/
    .test(t) ||
    /^I+V?G?\w$/
        .test(t);
exports.isClass = isClass;
const isRoom = (t) => /^\w\d+/
    .test(t) ||
    /^\(\d:\d\)/
        .test(t) ||
    /^\w \w+/
        .test(t) ||
    /^\w+ \d/
        .test(t);
exports.isRoom = isRoom;
const isTeacher = (t) => /\p{L}{2,} \p{L}{2,}( \p{L}{2,})?$/u.test(t) && !exports.isClass(t.split(" ").reverse()[0]);
exports.isTeacher = isTeacher;
const isStudent = (t) => {
    const split = t.split(" ");
    const last = [...split].reverse()[0];
    const exceptLast = [...split].slice(0, -1).join(" ");
    if (exports.isTeacher(exceptLast) && exports.isClass(last)) {
        return true;
    }
    return false;
};
exports.isStudent = isStudent;
function participantClassifier(text, useServiceIfError = true) {
    return __awaiter(this, void 0, void 0, function* () {
        const classifiers = [
            [exports.isClass, "class"],
            [exports.isRoom, "room"],
            [exports.isTeacher, "teacher"],
            [exports.isStudent, "student"],
        ];
        const matchedLabels = classifiers
            .filter(([isMatch]) => isMatch(text))
            .map(([_, labels]) => labels);
        if (matchedLabels.length === 1) {
            return matchedLabels[0];
        }
        else if (useServiceIfError) {
            return fetch(`/api/v1/participant/classify?participants=${text}`)
                .then((res) => res.json())
                .then((res) => {
                console.log(res);
                return res;
            })
                .then((res) => res.participants[0].labels[0]);
        }
        else if (matchedLabels.length === 0) {
            throw new Error(`Participant classification failed (0) - no matcher matched. Participant text: \`${text}\``);
        }
        else {
            throw new Error(`Participant classification failed (2+) - more than one matched. Participant text: \`${text}\`, matched labels: ${matchedLabels.join(", ")}`);
        }
    });
}
exports.participantClassifier = participantClassifier;
//# sourceMappingURL=scraperSpecificParticipantClassifier.js.map